/* Shared by both frontends — page translation breaks the react of either one the same way.

   A translator replaces the text nodes it translates with its own. React goes on holding the ones
   it created, so when it later takes such a subtree down it hands a parent a child that no longer
   belongs to it. The DOMException coming back out of that removal is thrown during the commit,
   where react has no way to recover from it, and the whole tree goes with it: the visitor asked for
   the flight planning and got the error page.

   Skipping those removals costs nothing. The nodes are the translator's by then, and whatever is
   left of them sits inside a subtree react has already given up on. Everything else keeps throwing
   as it did, so a parent-child mismatch of our own making would still surface. */

const isDetachedFrom = (parent, child) => Boolean(child) && child.parentNode !== parent;

export const survivePageTranslation = () => {
    if (typeof Node === 'undefined') return;

    const {insertBefore, removeChild} = Node.prototype;

    Node.prototype.removeChild = function removeTranslatedChild(child) {
        return isDetachedFrom(this, child) ? child : removeChild.call(this, child);
    };

    /* Without the node it was to go in front of, the new one still has to land somewhere. The end
       of the parent is where react would have put it had the translated node been gone entirely. */
    Node.prototype.insertBefore = function insertBeforeTranslatedChild(node, reference) {
        return isDetachedFrom(this, reference)
            ? this.appendChild(node)
            : insertBefore.call(this, node, reference);
    };
};
